import { isUnexpectedResponseError } from '@common/utils/fetcher';

import { type Account, getMeSettings } from '@services/AccountService';

import { hydrateSearchAges } from './hydrateSearchAges';
import { isAccount } from './isAccount';
import { useAccountStore } from './useAccountStore';

export const LEGACY_BACKEND_ACCOUNT: Account = {
  dating: true,
  matchmaker: false,
  hidden: false,
  allow_recommend: true,
  search: { age_from: null, age_to: null },
  features: { matchmaker: false, superlike: false },
};

export const receiveAccount = (account: Account) => {
  hydrateSearchAges(account);
  useAccountStore.getState().setAccount(account);
};

let pendingLoad: Promise<void> | null = null;

export const loadAccountSettings = () => {
  if (pendingLoad) return pendingLoad;

  useAccountStore.getState().setLoading(true);

  pendingLoad = getMeSettings()
    .then((settings: unknown) => {
      if (isAccount(settings)) receiveAccount(settings);
    })
    .catch((error: unknown) => {
      if (isUnexpectedResponseError(error)) {
        receiveAccount(LEGACY_BACKEND_ACCOUNT);
      }
    })
    .finally(() => {
      pendingLoad = null;
      useAccountStore.getState().setLoading(false);
    });

  return pendingLoad;
};
